module.exports = __webpack_public_path__ + "media/images/pic/practical_skills-97fdf1c05006623b259384f05c244096.svg";